import React from "react";

const Footer = () => {
  return (
    <div className="section">
      <div className="container px-5">
        <h3 className="subtitle">
          Crafted with 💘 in{" "}
          <span style={{ color: "crimson" }}>Bangladesh</span>
        </h3>
      </div>
    </div>
  );
};

export default Footer;
